import type { Me } from "@/features/session/toegang";
import type { PlanningDag } from "./usePlanning";

/**
 * Ids, never names: JBNL has more than one "Jeugdbrandweer Zuid", and Portaal is free to rename
 * a korps - matching on a name marks a stranger's ploeg one day and nothing the next.
 */
export const eigenKorpsIds = (me: Me): ReadonlySet<string> =>
  new Set(me.korpsen.map((korps) => korps.id));

/** What a wedstrijddag holds that belongs to the reader. */
export type EigenAandeel = {
  /** One of their korpsen hosts this dag. */
  organiseert: boolean;
  /** How many regels across the whole dag carry a ploeg of theirs. */
  ploegen: number;
  /** Whether the dag is theirs at all, which is what the block is marked on. */
  eigen: boolean;
};

/**
 * Hosting counts as well as playing, because the block names its organiserend korps. A session
 * holding no korpsen gets nothing marked, which is the honest answer.
 */
export function eigenAandeel(dag: PlanningDag, eigen: ReadonlySet<string>): EigenAandeel {
  const organiseert = dag.organiserendKorpsId != null && eigen.has(dag.organiserendKorpsId);

  const ploegen = dag.banen.reduce(
    (aantal, baan) =>
      aantal + baan.regels.filter((regel) => regel.korpsId != null && eigen.has(regel.korpsId)).length,
    0,
  );

  return { organiseert, ploegen, eigen: organiseert || ploegen > 0 };
}
